<template>
  <form
    class="simple-update-form"
    @submit.prevent="submitForm"
  >
    <div class="row bottom-xs">
      <div class="col-xs-5">
        <BaseFormField label="Importkode">
          <BaseSelect
            v-model="form.importRefferenceCodes"
            placeholder="Vælg importkode"
            class="default"
            tag-position="bottom"
            :options="localImportCodes"
            :multiple="true"
          />
        </BaseFormField>
      </div>
      <div class="col-xs-12">
        <BaseTextarea
          label="Beskrivelse"
          v-model="form.info.description"
          :disabled="loading"
        />
      </div>
      <div class="col-xs-12 xs-end">
        <BaseButton
          full
          label="Gem ændringer"
          :disabled="loading"
        />
      </div>
    </div>
    <div
      class="simple-update-form__loading"
      v-if="loading"
    >
      <BaseSpinner
        height="40px"
        width="40px"
      />
    </div>
  </form>
</template>

<script>
import BaseSelect from '../../BaseSelect.vue';
import BaseFormField from '../../BaseFormField.vue';
import BaseSpinner from '../../BaseSpinner.vue';
import BaseButton from '../../BaseButton.vue';
import BaseTextarea from '../../BaseTextarea.vue';
import RouteOfAdministrationService from '../../../services/RouteOfAdministrationService';

export default {
    name: 'UpdateRouteOfAdministationForm',
    components: {
        BaseTextarea, BaseButton, BaseSpinner, BaseFormField, BaseSelect,
    },
    props: {
        form: { type: Object, required: true },
        importCodes: { type: Array, required: true },
    },
    data() {
        return {
            loading: false,
            localImportCodes: [],
        };
    },
    methods: {
        async submitForm() {
            try {
                this.loading = true;
                const payload = await RouteOfAdministrationService.update(this.form);
                this.$emit('updated');

                this.$snotify.success(`${payload.info.name} er opdateret`);
                this.loading = false;
            } catch (error) {
                this.loading = false;
            }
        },
    },
    created() {
        this.localImportCodes = [...this.form.importRefferenceCodes, ...this.importCodes];
    },
};
</script>

<style lang="scss" scoped>
.simple-update-form {
    margin-top: 20px;
    background-color: $white2;
    padding: 10px;
    border-radius: 5px;
    position: relative;

    &__loading {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }
}
</style>
